import { render, staticRenderFns } from "./ShippingCheckpoint.vue?vue&type=template&id=605f18d9"
import script from "./ShippingCheckpoint.vue?vue&type=script&lang=js"
export * from "./ShippingCheckpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports